import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
export const ToggleButton = ({ name, value, onChange, isSelected, isDisabled = false, children, }) => {
    return (React.createElement(Wrapper, { as: "label", "data-testid": `value-toggle-${String(value)}`, isDisabled: isDisabled },
        React.createElement(VisuallyHiddenInput, { type: "radio", name: name, checked: isSelected, onClick: () => onChange(value), onChange: () => onChange(value) }),
        children));
};
const Wrapper = styled(Box) `
  cursor: pointer;
  ${({ isDisabled }) => isDisabled &&
    css `
      pointer-events: none;
      opacity: 0.5;
    `}
  padding: 10px 14px;
  transition: color 0.1s linear;
  height: fit-content;
  width: 100%;
  align-content: center;
  z-index: 3;
`;
const VisuallyHiddenInput = styled.input `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
//# sourceMappingURL=ToggleButton.js.map